import { AssignmentSections, PageTypes, PageViews, RouteResources, ScopeTypes } from './constants';

const getRoutePathname = (pathname = '') => {
    return pathname.replace(/^\/[a-z]{2}(?=\/|$)/, '') || '/';
};

const getRouteSegments = (pathname = '') => {
    return getRoutePathname(pathname).split('/').filter(Boolean);
};

const getAssignmentPageType = (segments = []) => {
    const [, assignmentId, section, detailId] = segments;

    if (!assignmentId) return PageTypes.ASSIGNMENTS;
    if (assignmentId === AssignmentSections.NEW) return PageTypes.ASSIGNMENT_CREATE;
    if (!section) return PageTypes.ASSIGNMENT_OVERVIEW;
    if (section === AssignmentSections.EDIT) return PageTypes.ASSIGNMENT_EDIT;
    if (section === AssignmentSections.GRADING) return PageTypes.GRADING;
    if (section === AssignmentSections.PREVIEW) return PageTypes.ASSIGNMENT_PREVIEW;
    if (section === AssignmentSections.SUBMISSIONS) {
        return detailId ? PageTypes.SUBMISSION_DETAIL : PageTypes.SUBMISSIONS;
    }

    return PageTypes.UNKNOWN;
};

const getRouteContext = (pathname = '') => {
    const segments = getRouteSegments(pathname);
    const [resource, assignmentId, section, detailId] = segments;

    if (!resource) {
        return {
            assignmentId: null,
            detailId: null,
            pageType: PageTypes.COURSE_DASHBOARD,
            scopeType: ScopeTypes.USER,
        };
    }

    if (resource === RouteResources.ASSIGNMENTS) {
        const resolvedAssignmentId = assignmentId && assignmentId !== AssignmentSections.NEW ? assignmentId : null;
        const pageType = getAssignmentPageType(segments);

        return {
            assignmentId: resolvedAssignmentId,
            detailId: detailId || null,
            pageType,
            pageView: section === AssignmentSections.SUBMISSIONS && !detailId ? PageViews.SUBMISSIONS : null,
            scopeType: resolvedAssignmentId ? ScopeTypes.ASSIGNMENT : ScopeTypes.COURSE,
        };
    }

    if (resource === RouteResources.PEOPLE) {
        return {
            assignmentId: null,
            detailId: null,
            pageType: PageTypes.PEOPLE,
            scopeType: ScopeTypes.COURSE,
        };
    }
    if (resource === RouteResources.COURSE_SETTINGS) {
        return {
            assignmentId: null,
            detailId: null,
            pageType: PageTypes.COURSE_SETTINGS,
            scopeType: ScopeTypes.COURSE,
        };
    }
    if (resource === RouteResources.RUBRICS) {
        return {
            assignmentId: null,
            detailId: null,
            pageType: PageTypes.RUBRICS,
            scopeType: ScopeTypes.COURSE,
        };
    }

    return {
        assignmentId: null,
        detailId: null,
        pageType: PageTypes.UNKNOWN,
        scopeType: ScopeTypes.USER,
    };
};

export const buildSessionContext = ({ auth, pathname }) => {
    const routeContext = getRouteContext(pathname);
    const courseId = routeContext.scopeType === ScopeTypes.USER ? null : auth?.course_id || null;

    return {
        pageContext: {
            page_type: routeContext.pageType,
            ...(routeContext.pageView ? { active_tab: routeContext.pageView } : {}),
        },
        routeContext,
        scope: {
            type: courseId ? routeContext.scopeType : ScopeTypes.USER,
            course_id: courseId,
            assignment_id:
                courseId && routeContext.scopeType === ScopeTypes.ASSIGNMENT ? routeContext.assignmentId : null,
        },
    };
};
